<template>
  <div class="input-parameters-homework-register">
    <div class="mb-1 group-type-radio">
      <label
        class="form-label is-required"
      >{{ $t('labels.groupType') }}</label>

      <!-- eslint-disable-next-line vue/no-v-html -->
      <span class="col-auto group-type-exp" v-html="$t('labels.groupTypeExp')"></span>
      <div class="col-auto  mt-1 mb-2">
        <input id="groupChoice1" v-model="groupType" type="radio" value="individual" :disabled="isPublished || (selectParams.headerInfo.isMyHomework == undefined ? false : (!selectParams.headerInfo.isMyHomework && selectParams.headerInfo.editMode == 'edit'))" @change="onSelectGroupType"/>
        <label for="groupChoice1" class="ps-1">
          <img src="@/assets/images/icon_individual.svg" width="15px">{{$t('labels.individualGroup')}}
        </label>
      </div>
      <div class="col-auto mb-2">
        <input id="groupChoice2" v-model="groupType" type="radio" value="share"  :disabled="isPublished || (selectParams.headerInfo.isMyHomework == undefined ? false : (!selectParams.headerInfo.isMyHomework && selectParams.headerInfo.editMode == 'edit'))" @change="onSelectGroupType"/>
        <label for="groupChoice2" class="ps-1">
          <img src="@/assets/images/icon_shared.svg" width="15px">{{$t('labels.shareGroup')}}
        </label>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-auto">
        <div class="condition-item-value">
          <label
            for="selectedGroup"
            class="form-label is-required"
          >{{ $t('labels.group') }}</label>
          <select
            v-model="selectedGroup"
            class="form-select form-select-sm"
            :disabled="isPublished"
            @change="onSelectGroup"
          >
            <option
              v-for="(group, key) in groupList"
              :key="key"
              :value="group.value"
              class="h6"
              v-text="group.label"  
            />
          </select> 
        </div>
      </div>             
    </div>
    <div v-if="groupType=='share'" class="row mb-1 editor-radio">
      <div class="-md-6 col-lg-5">
        <label class="form-label is-required">宿題の編集・返却が出来る人</label>
        <div class="row mt-1">
          <div class="col-auto required_transparent">
            <input id="editorChoice1" v-model="editor" type="radio" value="anyone" name="editor"  :disabled="selectParams.headerInfo.isMyHomework == undefined ? false : (!selectParams.headerInfo.isMyHomework && selectParams.headerInfo.editMode == 'edit')" @change="onSelectEditor" />
            <label for="editorChoice1" class="ps-1">だれでも</label>
          </div>
          <div class="col-auto">
            <input id="editorChoice2" v-model="editor" type="radio" value="onlyme" name="editor" :disabled="selectParams.headerInfo.isMyHomework == undefined ? false : (!selectParams.headerInfo.isMyHomework && selectParams.headerInfo.editMode == 'edit')" @change="onSelectEditor" />
            <label for="editorChoice2" class="ps-1">自分のみ</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-1">
      <div class="-md-6 col-lg-5">
        <FormTextField
          id="homeworkName"
          :label-text="$t('labels.homeworkName')"
          :initial-value="initialHomeworkName"
          :max-length="100"
          :is-require="true"
          @input="homeworkName = $event"
        />
      </div>
      <div class="col-auto col-category">
        <FormSelectBox
          id="category"
          ref="categorySelectBox"
          :label-text="$t('labels.category')"
          :options="generateCategoryItems"
          @input="onSelectCategory"
        />
        <a
          class="category-edit-link"
          href="#"
          @click.prevent="onClickCategoryEdit($event)"
        >
          編集
        </a>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-auto">
        <FormSelectBox
          id="curriculum"
          ref="curriculumSelectBox"
          :label-text="$t('labels.curriculum')"
          :options="generateCurriculumItems"
          :initial-value="initialCurriculum"
          :disabled="isPublished"
          :is-require="true"
          @input="onSelectCurriculum"
        />
      </div>
      <div class="col-auto">
        <FormSelectBox
          id="subject"
          ref="subjectSelectBox"
          :label-text="$t('labels.subject')"
          :options="generateSubjectItems"
          :initial-value="initialSubject"
          :disabled="isPublished"
          @input="selectedSubject = $event"
        />
      </div>
      <div class="col-auto">
        <FormDateField
          :label-text="$t('labels.startDate')"
          :model-value="startDate"
          :initial-value="initialStartDate"
          :disabled="isPublished"
          :date-range="startDateRange"
          :is-require="true"
          @update:model-value="onSelectedStartDate"
        />
      </div>
      <div class="col-auto">
        <FormDateField
          :label-text="$t('labels.deadlineDate')"
          :model-value="deadlineDate"
          :initial-value="initialDeadlineDate"
          :date-range="deadlineDateRange"
          :is-require="true"
          @update:model-value="onSelectedDeadlineDate"
        />
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-12">
        <div
          v-if="showCanNotGetTextbook"
          class="text-danger"
        >
          {{ $t("messages.error.canNotGetTextbook") }}
        </div>
        <div
          v-if="showCanNotGetStudent"
          class="text-danger"
        >
          {{ $t("messages.error.canNotGetStudent") }}
        </div>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col">
        <SelectGroupMembers
          ref="groupMembers"
          :options="generateGroupMemberItems"
          :initial-members="initialStreamGroupMembers"
          :is-add-only="isPublished"
          :is-require="true"
          @input="onSelectedGroupMembers"
          v-on="{
            'change-stream-my-self': onCheckedStreamMySelf,
          }"
        />
      </div>
      <div v-show="selectedGroupMembers.length > 100" class="mt-2 mb-2 text-danger">{{ $t("labels.recommendNumberOfDeliveryMessage") }}</div>
    </div>

    <!-- グループ選択用 -->
    <ModalConfirm
      v-if="showConfirmDeleteBySelectGroup"
      :message="confirmMessage"
      v-on="{
        'ok-confirm-modal': onOkShowConfirmDeleteBySelectGroup,
        'close-confirm-modal': onCloseConfirmModalGroup,
      }"
    />

    <!-- 教科選択用 -->
    <ModalConfirm
      v-if="showConfirmDeleteBySelectCurriculum"
      :message="confirmMessage"
      v-on="{
        'ok-confirm-modal': onOkShowConfirmDeleteBySelectCurriculum,
        'close-confirm-modal': onCloseConfirmModalCurriculum,
      }"
    />
    <ModalConfirmOkOnly
      v-if="isInvalidDateRange"
      :message="
        $t('messages.error.validateDateRange', {
          maxDeadlineDate:
            paramReleaseEndPeriodItems[0].items[0].value -
            paramDeadlinePeriodItems[0].items[0].value,
        })
      "
      @close-confirm-modal-ok-only="onClickInvalidDateRange()"
    />
  </div>
</template>
<script>
/**
 * 宿題管理 - 宿題作成 - ヘッダー設定項目コンポーネント
 */
import { mapGetters, mapMutations } from "vuex"
import { funcs } from "@/dbs/indexedDb"
import mixin from "@/mixins/mixin"
import FormTextField from "@/components/atoms/FormTextField.vue"
import FormSelectBox from "@/components/atoms/FormSelectBox.vue"
import FormDateField from "@/components/atoms/FormDateField.vue"
import SelectGroupMembers from "@/components/organisms/SelectGroupMembers.vue"
import ModalConfirm from "@/components/organisms/modal/ModalConfirm.vue"
import ModalConfirmOkOnly from "@/components/organisms/modal/ModalConfirmOkOnly.vue"
import convertValue from "../../repositories/convert-value"
import { homeworkTypeCode, category as categoryConstant } from "../../constant/homework"
import homeworkRepository from "@/repositories/homework"

export default {
  name: "InputParametersHomeworkRegister",
  components: {
    FormTextField,
    FormSelectBox,
    FormDateField,
    SelectGroupMembers,
    ModalConfirm,
    ModalConfirmOkOnly,
  },

  mixins: [mixin],

  props: {
    selectParams: {
      type: Object,
      default: function () {
        return {}
      },
    },
    isInvalidDateRange: { type: Boolean },
    isPublished: { type: Boolean },
    showCanNotGetStudent: { type: Boolean },
    showCanNotGetTextbook: { type: Boolean },
    streamGroupMember: {
      type: Object,
      default: function () {
        return {}
      },
    },
    hasAdditionalOptionIdStudentList: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },

  emits: [
    "select-group",
    "select-curriculum",
    "on-update-selected-group-members",
    "rollback-stream-member",
    "on-click-invalid-date-range",
    "edit-category",
  ],
  data: function () {
    return {
      homeworkName: "",
      selectedGroup: "0",
      // 現在のグループ
      currentGroup: "0",
      // 変更する前のグループ
      previousSelectedStream: "",
      selectedPreviousGroup: "",
      selectedCurriculum: "",
      // 変更する前の教科
      selectedPreviousCurriculum: "",
      selectedSubject: "",
      startDate: "",
      deadlineDate: "",
      initCategoryIndex: 0,
      selectedCategory: "",
      selectedCategoryIndex: 0,
      selectedGroupMembers: [],
      selectedIsStreamMySelf: false,
      // 削除対象の宿題（課題）インデックス一覧
      deleteHomeworkDetails: [],
      // 初期処理かどうかのフラグ
      isInit: true,
      // 配信データ一覧の削除確認フラグ
      showConfirmDeleteBySelectGroup: false,
      showConfirmDeleteBySelectCurriculum: false,
      // 確認メッセージ
      confirmMessage: "",
      // 確認ダイアログでOKを押したか？
      // HACK:現状どちらを選択してもclose-confirm-modalが走る（と言うか「キャンセルが押された」が取れない）のでこれが必要になる
      //      ModalConfirmの投げるイベントを見直すべきだが、影響範囲を考慮すると相応の工数が必要になると思われるので一旦保留
      isConfirmed: false,
      startDateRange: {},
      deadlineDateRange: {},
      groupType:"",
      currentGroupType: "",
      previousGroupType: "",
      editor:"",
      groupList: [],
    }
  },

  computed: {
    ...mapGetters("homework", ["categoryItems", "cmnCategoryItems", "homeworkDetailItems"]),

    /**
     * グループ一覧を生成
     * （FormSelectBox コンポーネントの配列形式に合わせるために変換）
     */
    generateGroupIdItems: function () {
      let groupItems;
      // 表示するグループ一覧を選択中のグループ種別に合わせる
      if(this.groupType == "share"){
        groupItems = this.loginUserInfo.shareGroupIds.map((x) => {
          return {
            label: x.groupName,
            value: x.groupId,
          }
        })
      }else{
        groupItems = this.loginUserInfo.groupIds.map((x) => {
          return {
            label: x.groupName,
            value: x.groupId,
          }
        })
      }
      
      groupItems.unshift({ label: this.$t("labels.pleaseSelect"), value: "0" })

      return groupItems
    },
    /**
     * 教科一覧を生成
     * （FormSelectBox コンポーネントの配列形式に合わせるために変換）
     */
    generateCurriculumItems: function () {
      let curriculumItems = this.nameCurriculums.items.map((x) => {
        return {
          label: x.name,
          value: x.code,
        }
      })
      curriculumItems.unshift({
        label: this.$t("labels.pleaseSelect"),
        value: "0",
      })

      return curriculumItems
    },
    /**
     * 選択した教科に紐づく科目一覧を生成
     */
    generateSubjectItems: function () {
      const unselected = { label: "　　　　　　", value: "0" }
      let subjectItems = []
      subjectItems.push(unselected)

      // 選択された教科
      const curriculum = Number(this.selectedCurriculum)
      // 選択していない場合は処理しない
      if (!curriculum || curriculum === 0) {
        return subjectItems
      }

      // 教科
      const foundCurriculumKey = this.nameCurriculums.keyItems.find(
        (ck) => Number(ck.code) === curriculum
      )
      // 科目
      let foundSubject = {}
      if (foundCurriculumKey) {
        foundSubject = this.nameSubjects.find(
          (s) => s.curriculumKey === foundCurriculumKey.name
        )
      }

      subjectItems = foundSubject.subjectItems.map((x) => {
        return {
          label: x.name,
          value: x.code,
        }
      })
      subjectItems.unshift(unselected)

      return subjectItems
    },
    /**
     * カテゴリーリストを生成
     */
    generateCategoryItems: function () {
      let categoryItems;
      if(this.groupType == "share"){
        categoryItems = this.cmnCategoryItems
      }else{
        categoryItems = this.categoryItems
      }
      const items = categoryItems.map((v) => {
        return {
          label: v,
          value: v,
        }
      })
      // 未設定を追加
      items.push({
        label: categoryConstant.noneName,
        value: categoryConstant.noneName,
      })
      return items
    },
    /**
     * 配信先グループメンバリストを生成
     */
    generateGroupMemberItems: function () {
      if (this.streamGroupMember.groupMemberItems.length === 0) {
        return []
      }
      return this.streamGroupMember.groupMemberItems.map((x) => {
        return {
          accountId: x.accountId,
          accountName: x.accountName,
          bookItems: x.bookItems,
        }
      })
    },
    /**
     * 宿題名の初期値
     */
    initialHomeworkName: function () {
      if (!Object.keys(this.selectParams.headerInfo).length) {
        return
      }
      return this.selectParams.headerInfo.homeworkName
    },
    /**
     * グループの初期値
     */
    initialStreamGroup: function () {
      if (!Object.keys(this.selectParams.headerInfo).length) {
        return "0"
      }
      if (this.selectParams.headerInfo.streamGroup === null) {
        return "0"
      }
      return String(this.selectParams.headerInfo.streamGroup)
    },
    /**
     * 教科の初期値
     */
    initialCurriculum: function () {
      if (!Object.keys(this.selectParams.headerInfo).length) {
        return "0"
      }
      return String(this.selectParams.headerInfo.curriculum)
    },
    /**
     * 科目の初期値
     * TODO: 値はセットできているが、選択状態にならないので調整が必要
     */
    initialSubject: function () {
      if (!Object.keys(this.selectParams.headerInfo).length) {
        return "0"
      }
      if (this.selectParams.headerInfo.subject === "0") {
        return "0"
      }
      return String(this.selectParams.headerInfo.subject)
    },
    /**
     * 開始日の初期値
     */
    initialStartDate: function () {
      if (!Object.keys(this.selectParams.headerInfo).length) {
        return ""
      }
      if (!this.selectParams.headerInfo.startDate) {
        return ""
      }
      return convertValue.toDateStringSeparatorZeroPadding(
        this.selectParams.headerInfo.startDate,
        "-"
      )
    },
    /**
     * 締切日の初期値
     */
    initialDeadlineDate: function () {
      if (!Object.keys(this.selectParams.headerInfo).length) {
        return ""
      }
      if (!this.selectParams.headerInfo.deadlineDate) {
        return ""
      }
      return convertValue.toDateStringSeparatorZeroPadding(
        this.selectParams.headerInfo.deadlineDate,
        "-"
      )
    },
    /**
     * 配信先グループメンバ一覧の初期値
     */
    initialStreamGroupMembers: function () {
      if (
        !this.selectParams.streamGroupMember.groupMemberItems ||
        this.selectParams.streamGroupMember.groupMemberItems.length === 0
      ) {
        return []
      }
      return this.selectParams.streamGroupMember.groupMemberItems.map((x) => {
        return {
          code: x.accountId,
          name: x.accountName,
          bookItems: x.bookItems,
        }
      })
    },
  },

  beforeMount() {
    // ※編集・コピー時に発生する問題
    // mountedのタイミングでは教科が選択されていない（厳密にはselectedCurriculumに値が入っていない）ため、
    // 教科未選択の状態でgenerateSubjectItemsが走ってしまい、その状態で初期値が確定してしまう
    // （存在しないものを選択してしまう。FormSelectBoxのmountメソッドで初期値がemitされるのはその後）
    // beforeMountでselectedCurriculumに値を放り込み、generateSubjectItemsが正しく動作するようにする
    this.selectedCurriculum = this.selectParams.headerInfo.curriculum
  },

  mounted: async function () {
    this.isInit = false
    // this.selectedPreviousGroup = this.selectedGroup
    this.selectedGroup = Object.keys(this.selectParams.headerInfo).length ? this.selectParams.headerInfo.streamGroup : "0"
    if(this.selectedGroup != "0"){
      await this.$emit("select-group", {
        group: this.selectedGroup,
        curriculum: this.selectedCurriculum,
        isInit: this.isInit,
      })
    }
    this.currentGroup = this.selectedGroup
    this.startDateRange = homeworkRepository.getStartDateRange()
    this.groupType = await this.getInitialGroupType()
    this.currentGroupType = this.groupType
    // カテゴリプルダウンの初期値を設定
    this.initCategoryIndex = await this.getInitialCategoryIndex()
    this.selectedCategoryIndex = this.initCategoryIndex
    let categoryItems = this.groupType == "share" ? this.cmnCategoryItems :this.categoryItems;
    this.selectedCategory = categoryItems[this.initCategoryIndex]
    if (!this.selectedCategory) {
      // 特定できない場合は未設定
      this.selectedCategory = categoryConstant.noneName
      this.selectedCategoryIndex = categoryItems.length - 1
    }
    this.$refs.categorySelectBox.setValue(this.selectedCategory)
    this.editor = await this.getInitialEditor()
    this.onSelectGroupType(undefined, true)
  },
  methods: {
    ...mapMutations("homework", ["deleteHomeworkDetailItemWithBookId","setInputGroupType"]),

    /**
     * カテゴリー初期値取得
     */
    getInitialCategoryIndex: async function () {
      // 初期値はカテゴリリストの終端（未設定）
      let categoryItems = this.groupType == "share" ? this.cmnCategoryItems :this.categoryItems;
      let categoryIndex = categoryItems.length;

      // 更新モードの場合
      if (Object.keys(this.selectParams.headerInfo).length) {
        // 更新モードの場合は保存済のものを表示
        if (categoryItems.indexOf(this.selectParams.headerInfo.category) >= 0) {
          categoryIndex = categoryItems.indexOf(this.selectParams.headerInfo.category)
        }
        return categoryIndex
      }

      // IndexedDBから前回値を取得
      let displayPreviousValues = await funcs.displayPreviousValues.get()
      let lastSelectedCategory =
        displayPreviousValues && displayPreviousValues.lastSelectedCategory
        ? displayPreviousValues.lastSelectedCategory
        : undefined

      if(this.groupType == "share"){
        lastSelectedCategory =
          displayPreviousValues && displayPreviousValues.lastSelectedCategoryShare
          ? displayPreviousValues.lastSelectedCategoryShare
          : undefined
      }

      // 前回値が取得できた＆前回値がリストに存在する場合はその値を一旦設定
      if (lastSelectedCategory && categoryItems.indexOf(lastSelectedCategory) >= 0) {
        categoryIndex = categoryItems.indexOf(lastSelectedCategory)
      }
      return categoryIndex
    },
    /**
     * グループ種別初期値取得
     */
    getInitialGroupType: async function () {
      // 更新モードの場合
      if (Object.keys(this.selectParams.headerInfo).length) {
        // 更新モードの場合は保存済のものを表示
        return this.selectParams.headerInfo.groupType
      }

      // 宿題一覧、宿題作成、表示制御画面で選択中のグループ種別をそろえるため、グループ種別は共通で保存
      let displayPreviousValues = await funcs.displayPreviousValues.get()
      let lastRegisterGroupType =
        displayPreviousValues && displayPreviousValues.lastFilter && displayPreviousValues.lastFilter.groupType
        ? displayPreviousValues.lastFilter.groupType
        : "individual"
      return lastRegisterGroupType
    },
    /**
     * 宿題編集者初期値取得
     */
    getInitialEditor: async function () {
      // 更新モードの場合
      if (Object.keys(this.selectParams.headerInfo).length) {
        return this.selectParams.headerInfo.editor
      }

      // IndexedDBから前回値を取得
      let displayPreviousValues = await funcs.displayPreviousValues.get()
      let lastRegisterEditor =
        displayPreviousValues && displayPreviousValues.lastRegisterEditor
        ? displayPreviousValues.lastRegisterEditor
        : "anyone"
      return lastRegisterEditor
    },
    /**
     * グループセレクトボックス選択
     */
    onSelectGroup: async function () {
      this.selectedPreviousGroup = this.currentGroup
      this.currentGroup = this.selectedGroup

      await this.$emit("select-group", {
        group: this.selectedGroup,
        curriculum: this.selectedCurriculum,
        isInit: this.isInit,
      })

      // グループリストの並び順を保存
      if(this.selectedGroup != "0"){
        const selectGroupIndex = this.groupList.findIndex((group) => {
          return group.value == this.selectedGroup
        })
        const selectGroup = this.groupList.find((group) => {
          return group.value == this.selectedGroup
        })
        if(selectGroupIndex != 0){
          this.groupList.splice(selectGroupIndex,1)
          this.groupList.splice(1,0,selectGroup)
        
          if(this.groupType){
            let displayPreviousValues = await funcs.displayPreviousValues.get();
            displayPreviousValues.groupSort = Object.assign({},displayPreviousValues.groupSort, {[this.groupType]: this.groupList.map((row) => {return [row['value']]} ).join(',')});
            await funcs.displayPreviousValues.put(displayPreviousValues);
          }
        }
      }
    },
    deleteHomeworkForNotExistBooks() {
      // 配信データ一覧より教材の問題をチェックして、誰も所有していなければ削除する
      // 初期表示時は処理させたくないのでフラグでチェックしている
      this.deleteHomeworkDetails = []
      if (!this.homeworkDetailItems || this.isInit) {
        return
      }
      if (this.streamGroupMember.groupMemberItems.length > 0) {
        this.homeworkDetailItems.forEach((x) => {
          // 教材の問題の場合
          if (x.questionType === homeworkTypeCode.textbook) {
            if (!this.hasAdditionalOptionIdStudentList[x.subQuestionInfo.teachingMaterials]) {
              // 通常の教材
              const found = this.streamGroupMember.groupMemberItems.some(
                (member) => {
                  return member.bookItems.some(
                    (bookItem) =>
                      bookItem.id === x.subQuestionInfo.teachingMaterials
                  )
                }
              )
              if (!found) {
                this.deleteHomeworkDetails.push({
                  bookId: x.subQuestionInfo.teachingMaterials,
                  name: x.taskName,
                })
              }
            } else {
              // 追加オプション教材
              const found = this.streamGroupMember.groupMemberItems.some((item) => {
                return this.hasAdditionalOptionIdStudentList[x.subQuestionInfo.teachingMaterials].find(v => item.accountId === v)
              })
              if (!found) {
                this.deleteHomeworkDetails.push({
                  bookId: x.subQuestionInfo.teachingMaterials,
                  name: x.taskName,
                })
              }
            }
          }
        })
      } else {
        this.homeworkDetailItems.forEach((x) => {
          this.deleteHomeworkDetails.push({
            bookId: x.subQuestionInfo.teachingMaterials,
            name: x.taskName,
          })
        })
      }
      if (
        !this.isPublished &&
        this.deleteHomeworkDetails.length > 0 &&
        this.initialStreamGroup !== this.selectedGroup
      ) {
        // 削除確認ダイアログメッセージを表示
        this.confirmMessage = this.$t(
          "messages.confirm.deleteHomeworkOnChangeGroupOrCurriculum"
        )
        // 箇条書きで課題名を列挙
        this.deleteHomeworkDetails.forEach(
          (x) => (this.confirmMessage += "・" + x.name + "\n")
        )
        this.isConfirmed = false
        this.showConfirmDeleteBySelectGroup = true
      }
    },
    /**
     * 教科セレクトボックス選択
     */
    onSelectCurriculum: function (event) {
      this.selectedPreviousCurriculum = this.selectedCurriculum
      this.selectedCurriculum = event

      // 教材があれば削除
      // 初期表示時は処理させたくないのでフラグでチェックしている
      if (!this.isInit && this.homeworkDetailItems.length) {
        this.homeworkDetailItems.forEach((x) => {
          if(x.questionType === homeworkTypeCode.textbook){
            this.deleteHomeworkDetails.push({
              bookId: x.subQuestionInfo.teachingMaterials,
              name: x.taskName,
            })
          }
        })
      }
      if (this.deleteHomeworkDetails.length > 0) {
        // 削除確認ダイアログメッセージを表示
        this.confirmMessage = this.$t(
          "messages.confirm.deleteHomeworkOnChangeGroupOrCurriculum"
        )
        // 箇条書きで課題名を列挙
        this.deleteHomeworkDetails.forEach(
          (x) => (this.confirmMessage += "・" + x.name + "\n")
        )
        this.isConfirmed = false
        this.showConfirmDeleteBySelectCurriculum = true
        return
      }

      this.$emit("select-curriculum", {
        group: this.selectedGroup,
        curriculum: this.selectedCurriculum,
        isInit: this.isInit,
      })
      if (!this.isInit) {
        // 科目の初期化
        // ※初期表示時は処理させたくないのでフラグを確認
        this.selectedSubject = "0"
        this.$refs.subjectSelectBox.setValue(this.selectedSubject)
      }
    },
    /**
     * 開始日選択
     */
    onSelectedStartDate: function (event) {
      this.startDate = event
      this.deadlineDateRange = homeworkRepository.getDeadlineDateRange(
        event,
        this.paramReleaseEndPeriodItems[0].items[0].value,
        this.paramDeadlinePeriodItems[0].items[0].value
      )
    },
    /**
     * 締切日選択
     */
    onSelectedDeadlineDate(event) {
      this.deadlineDate = event
    },
    /**
     * 配信先グループメンバ選択
     */
    onSelectedGroupMembers: function (event) {
      this.selectedGroupMembers = event
      this.$emit("on-update-selected-group-members", event)
    },
    /**
     * 自分にも配信するチェックボックスをチェック
     */
    onCheckedStreamMySelf: function (event) {
      this.selectedIsStreamMySelf = event
    },
    /**
     * 教科確認ダイアログ「OK」押下
     */
    onOkShowConfirmDeleteBySelectCurriculum: async function () {
      this.deleteHomeworkDetails.forEach((x) =>
        this.deleteHomeworkDetailItemWithBookId(x.bookId)
      )
      this.deleteHomeworkDetails = []

      this.isConfirmed = true
    },
    /**
     * グループ確認ダイアログ「OK」押下
     */
    onOkShowConfirmDeleteBySelectGroup: async function () {
      this.deleteHomeworkDetails.forEach((x) =>
        this.deleteHomeworkDetailItemWithBookId(x.bookId)
      )
      this.deleteHomeworkDetails = []

      this.isConfirmed = true
    },
    /**
     * グループ選択時確認ダイアログ「キャンセル」押下
     */
    onCloseConfirmModalGroup: async function () {
      // グループを選択前の状態に戻す
      if (!this.isConfirmed) {
        // グループ種別を戻す
        if (this.previousGroupType != "") {
          this.groupType = this.previousGroupType
          this.currentGroupType = this.previousGroupType
        }
        // 変更操作ではないのでtrueでグループ種別変更処理を呼び出し
        this.onSelectGroupType(undefined, true)
        // グループを戻す
        this.selectedGroup = this.selectedPreviousGroup
        this.currentGroup = this.selectedPreviousGroup
        await this.$emit("rollback-stream-member")
      }

      this.showConfirmDeleteBySelectGroup = false
    },
    onCloseConfirmModalCurriculum: function () {
      if (!this.isConfirmed) {
        // 教科を選択前の状態に戻す
        this.selectedCurriculum = this.selectedPreviousCurriculum
        this.$emit("select-curriculum", {
          group: this.selectedGroup,
          curriculum: this.selectedCurriculum,
        })
        this.$refs.curriculumSelectBox.setValue(this.selectedCurriculum)
      } else {
        // 科目の初期化
        this.selectedSubject = "0"
        this.$refs.subjectSelectBox.setValue(this.selectedSubject)
      }

      this.showConfirmDeleteBySelectCurriculum = false
    },
    /**
     * 必須項目が入力されているか？
     */
    // TODO: バリデーションは、VeeValidate を使用するように変更する
    validateRequiredParameters: function () {
      // 宿題名
      if (!this.homeworkName) {
        return false
      }

      // グループ
      if (this.selectedGroup <= 0) {
        return false
      }

      // 科目
      if (this.selectedCurriculum <= 0) {
        return false
      }

      // 配信先
      if (this.selectedGroupMembers.length === 0) {
        return false
      }

      // 開始日
      if (!this.startDate) {
        return false
      }

      // 締切日
      if (!this.deadlineDate) {
        return false
      }

      return true
    },
    async setInitialMembers() {
      await this.$refs.groupMembers.setInitialMembers()
    },
    onClickInvalidDateRange() {
      this.$emit("on-click-invalid-date-range")
    },
    /**
     * カテゴリ選択変更時
     */
    async onSelectCategory(event) {
      if (!event) {
        return
      }
      // 選択値を前回値としてIndexedDBに保存
      this.selectedCategory = event
      let categoryItems = this.groupType == "share" ? this.cmnCategoryItems :this.categoryItems;
      this.selectedCategoryIndex = categoryItems.indexOf(this.selectedCategory)
      let displayPreviousValues = await funcs.displayPreviousValues.get()
      if(this.groupType == "share"){
        Object.assign(displayPreviousValues, {
          lastSelectedCategoryShare: event
        })      
      }else{
        Object.assign(displayPreviousValues, {
          lastSelectedCategory: event
        })
      }
      await funcs.displayPreviousValues.put(displayPreviousValues)
    },
    /**
     * カテゴリ編集リンク押下時
     */
    onClickCategoryEdit: function () {
      this.$emit("edit-category")
      return false
    },
    /**
     * カテゴリ設定
     */
    setCategory(v) {
      this.$nextTick(() => {
        let newSelectValue = categoryConstant.noneName
        let categoryItems = this.groupType == "share" ? this.cmnCategoryItems :this.categoryItems;
        try {
          if (v.action === 'del') {
            if (v.actionRow === this.selectedCategoryIndex) {
              // 選択中のカテゴリーが削除された場合は、「未設定」にする
              newSelectValue = categoryConstant.noneName
              return
            }
            if (v.actionRow < this.selectedCategoryIndex) {
              // 選択中のカテゴリーより前方が削除された場合は1つ繰り上げ
              newSelectValue = categoryItems[this.selectedCategoryIndex - 1]
              return
            }
          }
          if (!this.selectedCategory || this.selectedCategory === categoryConstant.noneName) {
            newSelectValue = categoryConstant.noneName
            return
          }
          // その他の場合は現在の選択位置を維持
          newSelectValue = categoryItems[this.selectedCategoryIndex]
        } finally {
          this.$refs.categorySelectBox.setValue(newSelectValue)
          this.onSelectCategory(newSelectValue)
        }
      })
    },
    /**
     * グループ種別ラジオボタン変更時
     */
    async onSelectGroupType(_e, isMounted = false) {
      this.groupList = this.generateGroupIdItems;
      if(!Object.keys(this.selectParams.headerInfo).length){
        //更新時でない場合はグループセレクトボックスとカテゴリーセレクトボックスに初期値を設定
        this.selectedGroup = "0";
        await this.$emit("select-group", {
          group: this.selectedGroup,
          curriculum: this.selectedCurriculum,
          isInit: this.isInit,
        })
        this.initCategoryIndex = await this.getInitialCategoryIndex();
        let categoryItems = this.groupType == "share" ? this.cmnCategoryItems :this.categoryItems;
        this.selectedCategoryIndex = this.initCategoryIndex
        this.selectedCategory = categoryItems[this.initCategoryIndex]
        if (!this.selectedCategory) {
          // 特定できない場合は未設定
          this.selectedCategory = categoryConstant.noneName
          this.selectedCategoryIndex = categoryItems.length - 1
        }
        this.$refs.categorySelectBox.setValue(this.selectedCategory)
      }
      // 選択値を前回値としてIndexedDBに保存(グループ種別)
      let displayPreviousValues = await funcs.displayPreviousValues.get()
      displayPreviousValues.lastFilter = Object.assign({},displayPreviousValues.lastFilter, {["groupType"]: this.groupType});
      this.setInputGroupType(this.groupType);
      await funcs.displayPreviousValues.put(displayPreviousValues)
      
      // IndexedDBから前回値を取得(グループリストのソート順)
      let lastRegisterGroupSort = displayPreviousValues && displayPreviousValues.groupSort
        ? displayPreviousValues.groupSort
        : null
      if(lastRegisterGroupSort && lastRegisterGroupSort[this.groupType]){
        this.groupList.sort((a, b) => {
          return lastRegisterGroupSort[this.groupType].indexOf(String(a.value)) - lastRegisterGroupSort[this.groupType].indexOf(String(b.value));
        });

        // indexedDBに保存したソート順に存在しないグループがある場合、最後尾に追加
        const newGroup = this.groupList.map(group => group.value.toString()).filter(item => lastRegisterGroupSort[this.groupType].split(",").indexOf(item) == -1)
        if(newGroup.length > 0){
          const matchingObjects = this.groupList.filter(item => newGroup.includes(item.value.toString()));
          this.groupList = this.groupList.filter(item => !newGroup.includes(item.value.toString()));
          this.groupList.push(...matchingObjects);
        }
      }
      // 初期表示時でないグループ種別切り替えの場合はグループを初期化
      if (!isMounted) {
        this.previousGroupType = this.currentGroupType
        this.currentGroupType = this.groupType
        this.selectedPreviousGroup = this.currentGroup
        this.selectedGroup = "0"
        this.onSelectGroup()
      }
    },
    /**
     * 宿題編集者ラジオボタン変更時
     */
    async onSelectEditor(event) {
      if (!event) {
        return
      }
      // 選択値を前回値としてIndexedDBに保存
      let displayPreviousValues = await funcs.displayPreviousValues.get()
      Object.assign(displayPreviousValues, {
        lastRegisterEditor: this.editor
      })
      await funcs.displayPreviousValues.put(displayPreviousValues)
    },
  },
}
</script>
<style lang="scss" scoped>
.input-parameters-homework-register {
  .col-category {
    position: relative;
    width: 280px;

    .category-edit-link {
      position: absolute;
      top: 0;
      right: 0;
      padding-right: 20px;
      font-size: 85%;
    }
  }
}

.group-type-radio{
  div,div > label{
    display: flex;
    align-items: center;
    img{
      margin-right: 3px;
    }
  }
}
label{
  &.is-required {
    &::before{
      content: "*";
      color: red;
    }
  }
}
:deep(.form-label) {
  display: inline;
}
.group-type-exp{
  margin-left: 35px;
}
</style>
